var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.841 24.0065C29.7805 15.3527 14.608 16.4999 5.96299 26.568C-2.67127 36.6237 -1.52584 51.773 8.52219 60.4163L49.4553 95.626L49.7763 96L49.8333 95.951L49.8903 96L50.2113 95.626L91.1443 60.4163C101.192 51.773 102.338 36.6237 93.7036 26.568C85.0586 16.4999 69.886 15.3527 59.8256 24.0065L49.8333 32.6017L39.841 24.0065Z",
    fill: "#4c2e61"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg7);
export default __webpack_public_path__ + "static/media/7.aa0c7d60624c636f3dcadeb01b74ca43.svg";
export { ForwardRef as ReactComponent };